__turbopack_context__.v({
  "component": "style-module-scss-module__bc8WZq__component",
  "container": "style-module-scss-module__bc8WZq__container",
});
